<div class="row g-0 about-us-card">
<!-- Close button -->
  <button 
    type="button" 
    class="btn-close position-absolute m-3" 
    aria-label="Close"
    (click)="closeCard()">
  </button>
 
  <div class="col-md-4 p-4 about-us-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Where Ideation Meets Execution</h2>
    <p class="text-gray small mb-0">
      Kalpita, an outcome-focused company aimed at delivering unique, reliable, 
      and innovative software solutions using an agile approach to rapid software 
      delivery for small and large-scale businesses.
    </p>
  </div>
  
  <div class="col-md-8 p-4 bg-white">
    <h3>About Us</h3>
    <ul class="list-unstyled mb-0">
      <li><a href="javascript:void(0)" class="dropdown-item" (click)="navigateTo('aboutcompany/about-kalpita-technologies')">About Kalpita</a></li>
      <li><a href="javascript:void(0)" class="dropdown-item"
       (click)="navigateTo('aboutcompany/kalpita-csr')" >Social Responsibility</a></li>
    <li>
        <a href="javascript:void(0)" class="dropdown-item"
           (click)="navigateTo('news-letters/newsletter')">News Letter</a>
    </li>
    <li>
        <a href="javascript:void(0)" class="dropdown-item"
           (click)="navigateTo('aboutcompany/kalpita-annual-reports')">Annual Report</a>
    </li>
       <li><a class="dropdown-item" href="../../../assets/brochure/Kalpita_Brochure.pdf" target="_blank">KT Brochure</a></li>
    </ul>
  </div>
</div>